import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { CustomLink, Image } from '@teko/ds-desktop';
import { g as getImageUrlFromGoogleUserContent } from './image-b1bfb7c2.js';

const EnhancedImage = (props) => {
    const { src, googleImageParams, link, tracking } = props, rest = __rest(props, ["src", "googleImageParams", "link", "tracking"]);
    return (jsx(CustomLink, Object.assign({}, link, { children: jsx(Image, Object.assign({}, tracking, rest, { src: getImageUrlFromGoogleUserContent(src, Object.assign({ format: 'webp' }, googleImageParams)), pngSrc: getImageUrlFromGoogleUserContent(src, Object.assign({ format: 'png' }, googleImageParams)) }), void 0) }), void 0));
};

export { EnhancedImage as E };
